/* eslint no-multi-spaces: "off" */
import React from 'react';

const LocationPin = () => (
  <svg className="location-pin" height="12px" version="1.1" viewBox="0 0 9 12" width="9px" xmlns="http://www.w3.org/2000/svg">
    <title>icon_pin small</title>
    <desc>Created with Sketch.</desc>
    <g fill="none" fillRule="evenodd" id="icon_pin-small" stroke="none" strokeWidth="1">
      <path className="location-pin--outline-path" d="M4.5,0 C2.025,0 0,2.03591416 0,4.54165467 C0,5.53351029 0.325,6.47316299 0.9,7.25620689 L4.3,11.9022674 C4.375,12.0066733 4.55,12.0327747 4.65,11.9544704 C4.675,11.9283689 4.675,11.9283689 4.7,11.9022674 L8.1,7.25620689 C8.675,6.47316299 9,5.53351029 9,4.54165467 C9,2.03591416 6.975,0 4.5,0 Z M4.21342361,5.96785537 C3.39720422,5.79641735 2.86021778,5.02494626 3.03205344,4.21061566 C3.2038891,3.39628506 3.97714958,2.86054125 4.79336896,3.03197927 C5.39479378,3.16055778 5.86734184,3.61058259 5.97473913,4.21061566 C6.12509534,5.02494626 5.5881089,5.8178471 4.79336896,5.96785537 C4.60005385,6.01071488 4.40673873,6.01071488 4.21342361,5.96785537 Z" fillRule="nonzero" id="icon_pin-copy" />
    </g>
  </svg>
);

export default LocationPin;
